import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import './notifySnackbar.scss';
var snackbarCount = 0;

function NotifySnackbar(props) {
  var {
    children,
    className,
    close,
    darkMode = false,
    notifyError = false
  } = props;
  var [snackbarOpen, setSnackbarOpen] = useState(false);
  var [snackbarClosing, setSnackbarClosing] = useState(false);

  var closeSnackbar = () => {
    if (snackbarClosing) {
      return;
    }

    setSnackbarClosing(true);
    setTimeout(close, 300);
  };

  useEffect(() => {
    snackbarCount++;
    var snackbarsContainer = document.querySelector('.notifySnackbarsContainer');
    snackbarsContainer.style.height = snackbarCount * 50 + (snackbarCount - 1) * 10 + 'px'; // setSnackbarOpen(true); // trigger opening animation

    setTimeout(() => setSnackbarOpen(true), 10); // trigger opening animation

    setTimeout(() => closeSnackbar(), 5 * 1000); // close snackbar after 5 seconds

    return () => {
      snackbarCount--;
      snackbarsContainer.style.height = snackbarCount * 50 + (snackbarCount - 1) * 10 + 'px';
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('notifySnackbar', {
      snackbarOpen,
      snackbarClosing,
      darkMode,
      notifyError
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "snackbarText"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "closeX noSelect",
    onClick: () => closeSnackbar()
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "timerBar"
  }));
}

export default NotifySnackbar;